<template>
    <common-modal width="huge" height="max-height-small">
        <video-player
            :src="videoSrc"
            controls
            class="video-js vjs-default-skin vjs-big-play-centered"
            :autoplay="true"
            :volume="0.6"
        ></video-player>
    </common-modal>
</template>

<script>
    import { VideoPlayer } from '@videojs-player/vue'
    import 'video.js/dist/video-js.css'

    export default {
        components: {
            VideoPlayer,
        },
        props: {
            videoSrc: { type: String, required: true },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_mixins.scss';
    @import 'styles/setup/_variables.scss';

    .video-js {
        width: 100%;
        max-height: 400px;
        @include breakpoint(smartphone-large) {
            margin-top: 100px;
        }
    }
</style>
